import { z } from 'zod';

const landContourDetailSchema = z
  .object({
    fond_type_id: z.string().min(1, ''),
    land_extra_irragation: z.string().min(1, ''),
    land_type: z.string().min(1, ''),
    massiv_id: z.string().min(1, ''),
    plant_type_id: z.string().min(1, ''),
    selected: z.boolean(),
  })
  .passthrough();

export const landFormSchema = z.object({
  crop: z.string(),
  value: z.array(landContourDetailSchema).min(1, ''),
});
export type LandFormValues = z.infer<typeof landFormSchema>;
